import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import '../css/history.css';
import bgImage from "../assets/background-4.jpg";

export default function Help() {
  return (
    <>
      <Navbar />
      <PageHeader title="Help & Support" path="/help" name="Help" bgImage={bgImage} />
      <div className="history-page container-xxl py-5">
        <div className="container">
          <div className="history-intro">
            <h1>Get Help Using the D.R.Y Website</h1>
            <p className="lead">
              Practical guidance for citizens and visitors so you can quickly find information, complete forms and reach
              the right public offices.
            </p>
          </div>

          <div className="history-section">
            <h3>1. Finding Information Quickly</h3>
            <p>
              The main navigation menu groups content by theme, such as history, culture, landmarks and national
              programmes.
            </p>
            <ul>
              <li>Use the top menu to move between pages without losing your place.</li>
              <li>The Gallery section highlights visual stories, videos and key national symbols.</li>
              <li>Service forms and programmes are usually accessible from the “Possess Our Possessions” section.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>2. Using Forms and Applications</h3>
            <p>
              Several pages provide online forms for data collection and specific initiatives of the D.R.Y.
            </p>
            <ul>
              <li>Read the instructions above each form carefully before you begin.</li>
              <li>Have required documents or photos ready on your device to avoid timeouts.</li>
              <li>Submit only accurate information; incorrect details may delay or block processing.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>3. Accessibility and Device Support</h3>
            <p>
              The site is designed to work on modern phones, tablets and computers, and to be readable for a wide range
              of users.
            </p>
            <ul>
              <li>Zoom in or out using your browser controls if text appears too small.</li>
              <li>If a page does not display correctly, try refreshing or using another browser.</li>
              <li>Report serious accessibility issues to the Executive Office using the contact details in the footer.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>4. Technical Problems</h3>
            <p>
              Sometimes pages may load slowly or links may not work as expected due to network or maintenance issues.
            </p>
            <ul>
              <li>Check your internet connection and try again after a short time.</li>
              <li>Note the page address and any error message you see.</li>
              <li>Share these details when you contact support so that issues can be fixed quickly.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>5. Feedback and Suggestions</h3>
            <p>
              Your comments help improve the digital experience for citizens of the D.R.Y and friends around the world.
            </p>
            <ul>
              <li>Use the Contact page to send general feedback or questions.</li>
              <li>For ideas about new features or content, explain the benefit for citizens or communities.</li>
              <li>Respectfully highlight any errors you notice in text, images or translations.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>6. Data, Privacy and Safety</h3>
            <p>
              Understanding how your information is used helps you stay in control of your digital footprint.
            </p>
            <ul>
              <li>Read the Terms of Use, Privacy Policy and Cookies Notice for full details.</li>
              <li>Do not share passwords or sensitive personal data in public forms.</li>
              <li>Contact us if you suspect any misuse of your information or the website.</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
}
